import React, { Component } from 'react';
import { Row, Col, Divider, Select} from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { ModalItem, Form,  FormItem, InputItem, SelectItem, ButtonItem } from '../../../../Components/Items';

const { Option }  = Select; 

class ModalTransicionConfig extends Component {
  formRef = React.createRef();

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      if (this.props.transicionAEditar) {
        this.formRef.current?.setFieldsValue(this.props.transicionAEditar);
      } else {
        this.formRef.current?.resetFields();
        this.formRef.current?.setFieldsValue({
          nombreTransicion: `Pasar a ${this.props.destinoNombre}`,
          documentoRequerido: 'Ninguno',
          campos: [] 
        });
      }
    }
  }

  onFinish = (values) => {
    const { origenId, destinoId, transicionAEditar } = this.props;
    
    const payload = {
      ...values,
      estadoEmbudoOrigen: origenId,
      estadoEmbudoDestino: destinoId,
      _id: transicionAEditar ? transicionAEditar._id : null
    };

    this.props.onSave(payload);
  };

  render() {
    const { visible, onCancel, origenNombre, destinoNombre } = this.props;

    return (
      <ModalItem
        title={`Configurar Transición: ${origenNombre} ➔ ${destinoNombre}`}
        visible={visible}
        onCancel={onCancel}
        width={750}
        paddingTop
        spinning = {false}
      >
        <Form
          ref={this.formRef}
          name="form_transicion"
          layout="vertical"
          onFinish={this.onFinish}
          bottom={
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <ButtonItem rojo onClick={onCancel} style={{ marginRight: 8 }}>Cancelar</ButtonItem>
              <ButtonItem azul htmlType="submit">Guardar Transición</ButtonItem>
            </div>
          }
        >
          <Row gutter={16}>
            <Col span={12}>
              <FormItem name="nombreTransicion" label="Nombre de la Acción" required margin wrapperCol = {12} labelCol = {12}>
                <InputItem placeholder="Ej: Generar Cotización" />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem name="documentoRequerido" label="Ligar a Documento" required margin tooltip="Si seleccionas uno, el sistema pedirá este documento al mover el lead." wrapperCol = {12} labelCol = {12}>
                <SelectItem placeholder="Documento">
                  <Option value="Ninguno">Ninguno</Option>
                  <Option value="Cotizacion">Cotización</Option>
                  <Option value="Pedido">Pedido</Option>
                  <Option value="Venta">Venta - Remisión</Option>
                  <Option value="Requisicion">Requisición</Option>
                  <Option value="OrdenDeCompra">Orden de Compra</Option>
                  <Option value="Factura">Factura</Option>
                </SelectItem>
              </FormItem>
            </Col>
          </Row>

          <Divider style={{ margin: "12px 0" }} />
          <p style={{ color: '#5e6c84', fontSize: '13px', marginBottom: 15 }}>
            <b>Campos Dinámicos:</b> Define qué información extra debe llenar el vendedor al hacer este movimiento.
          </p>

          <Form.List name="campos">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Row 
                    gutter={12} 
                    key={key} 
                    style={{ marginBottom: 15, display: 'flex', alignItems: 'flex-start' }}
                  >
                    <Col span={12}>
                      <FormItem {...restField} name={[name, 'nombre']} margin={false} required wrapperCol = {12} labelCol = {12} style={{ marginBottom: 0 }}>
                        <InputItem placeholder="Nombre del campo (Ej. Motivo)" />
                      </FormItem>
                    </Col>
                    <Col span={10}>
                      <FormItem {...restField} name={[name, 'tipo']} margin={false} required wrapperCol = {12} labelCol = {12} style={{ marginBottom: 0 }}>
                        <SelectItem placeholder="Tipo de dato">
                          <Option value="text">Texto Libre</Option>
                          <Option value="number">Número / Moneda</Option>
                          <Option value="date">Fecha</Option>
                          <Option value="boolean">Verdadero / Falso</Option>
                          
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={2} style={{ display: 'flex', justifyContent: 'center', paddingTop: '4px' }}>
                      <ButtonItem 
                        rojo 
                        icon={<DeleteOutlined />} 
                        onClick={() => remove(name)} 
                        style={{ padding: '0 8px' }} 
                        tooltip="Eliminar campo"
                      />
                    </Col>
                  </Row>
                ))}
                <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />} style={{ marginTop: 10 }}>
                  Añadir Campo Extra
                </ButtonItem>
              </>
            )}
          </Form.List>
        </Form>
      </ModalItem>
    );
  }
}

export default ModalTransicionConfig;